import React, { useEffect, useState } from 'react'
import { gameStatusState, useUpdateGameStatus } from '../../globalStates/general/gameStatus';
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { selectSquareAreaState } from '../../globalStates/general/selectSquare';
import { selectedSquaresState } from '../../globalStates/general/selectedSquares';
import { selectSquareBtnColorState } from '../../globalStates/general/selectSquareBtnColor';
import { player1CurrentSquaresState } from '../../globalStates/general/player1CurrentSquare';
import { gameStatusInfoDisplayState } from '../../globalStates/general/gameStatusInfo';
import { isReverseState } from '../../globalStates/general/reverse';
import { fieldDataState } from '../../globalStates/general/fieldData';
import { boolDrugonEggState } from '../../globalStates/item/drugonEgg';
import { useMedia } from 'use-media';


const SelectMoveSquaresMenu = (props) => {

  // game status
  // 1: choice
  // 2: get the word or item
  // 3: use the word or item ? 4 : 1
  // 4: function for use word or use item → game complete ? end : 1
  const setGameStatusValue = useSetRecoilState(gameStatusState);
  const [selectedSquare, setSelectedSquare] = useRecoilState(selectedSquaresState);
  const [btnColor, setBtnColor] = useRecoilState(selectSquareBtnColorState);
  const [player1Square, setPlayer1Square] = useRecoilState(player1CurrentSquaresState);
  const [reverse, setReverse] = useRecoilState(isReverseState);
  // フィールドのデータを管理する
  const [fieldData, setFieldData] = useRecoilState(fieldDataState);
  const boolDrugonEgg = useRecoilValue(boolDrugonEggState);
  const isPC = useMedia({ minWidth: '1000px' });



  //　次に進むマスを計算する
  const calcNextGrid = (btnId, status) => {
    let nextGrid;
    const maxGridNum = fieldData.length - 1;
    const minGridNum = 1; // 0はスタート地点となるため1が一番小さい場所となる

    // 跳ね返る以外の進み
    if (reverse) {
      // リバースされている
      nextGrid = player1Square - btnId;
    } else {
      // リバースされていないとき
      nextGrid = player1Square + btnId;
    }

    // 跳ね返る処理
    if (nextGrid > maxGridNum) { // 右下での
      const diff = nextGrid - maxGridNum; // 今いるプレイヤーの位置と一番大きいマスの距離をとる
      nextGrid = maxGridNum - diff; // 進むマスを計算する(いい感じに)
      if (status === "set") setReverse(true);// ボタンが押されている時に進む方向を反転させる
    } else if (nextGrid < minGridNum) { // 左上での
      const diff = player1Square - minGridNum; // 今いるプレイヤーの位置と一番小さいマスの距離をとる
      nextGrid = minGridNum + (btnId - diff);// 上の差を進むマス数で埋めてから右に進む
      if (status === "set") setReverse(false); // ボタンが押されている時に進む方向を反転させる
    }
    return nextGrid;
  }

  // 進むマスのボタンにホバーした時、進むマスにアニメーションを施す。
  const handleHover = (btnId, status) => {
    if (fieldData.length === 0) return;
    if (status === "hover") {
      const nextFieldData = [...props.fieldData];
      const nextGrid = calcNextGrid(btnId, "nextGridDisplay");
      nextFieldData[nextGrid] = {
        isWord: fieldData[nextGrid].isWord,
        isTrap: fieldData[nextGrid].isTrap,
        contents: fieldData[nextGrid].contents,
        player: fieldData[nextGrid].player,
        checked: fieldData[nextGrid].checked,
        word_top: fieldData[nextGrid].word_top,
        word_bottom: fieldData[nextGrid].word_bottom,
        explanation: fieldData[nextGrid].explanation,
        part_of_speech: fieldData[nextGrid].part_of_speech,
        isNextGrid: true,
      }
      setFieldData(nextFieldData);
    }
    else if (status === "leave") {
      const nextFieldData = [...props.fieldData];
      for (let i = 0; i < nextFieldData.length; i++) {
        nextFieldData[i] = {
          isWord: fieldData[i].isWord,
          isTrap: fieldData[i].isTrap,
          contents: fieldData[i].contents,
          player: fieldData[i].player,
          checked: fieldData[i].checked,
          word_top: fieldData[i].word_top,
          word_bottom: fieldData[i].word_bottom,
          explanation: fieldData[i].explanation,
          part_of_speech: fieldData[i].part_of_speech,
          isNextGrid: false,
        }
      }
      setFieldData(nextFieldData);
    }
  }

  useEffect(() => {
    if (boolDrugonEgg) {
      if (selectedSquare[0] || selectedSquare[1] || selectedSquare[2]) {
        setSelectedSquare([false, false, false]);
        setBtnColor([["#ffffff", "#555555"], ["#ffffff", "#555555"], ["#ffffff", "#555555"]]);
      }
    } else {
      if (selectedSquare[0] && selectedSquare[1] && selectedSquare[2]) {
        setSelectedSquare([false, false, false]);
        setBtnColor([["#ffffff", "#555555"], ["#ffffff", "#555555"], ["#ffffff", "#555555"]]);
      } else if (!selectedSquare[0] && !selectedSquare[1] && !selectedSquare[2]) {
        setBtnColor([["#ffffff", "#555555"], ["#ffffff", "#555555"], ["#ffffff", "#555555"]]);
      }
    }
  }, [selectedSquare, boolDrugonEgg]);

  // ボタンが選択されたらstateをそれぞれ更新する
  const handleSelect = (value) => {
    const arrayIndex = value - 1;//　-1する理由: valueは1からの値であるが、配列は0から始まるため
    if (selectedSquare[arrayIndex] === false) {
      const tmp_arr = [];
      const tmp_btn_color_arr = [[], [], []];
      for (let i = 0; i < 3; i++) {
        tmp_arr[i] = selectedSquare[i];
        tmp_btn_color_arr[i][0] = btnColor[i][0];
        tmp_btn_color_arr[i][1] = btnColor[i][1];
      }
      tmp_arr[arrayIndex] = true;
      tmp_btn_color_arr[arrayIndex][0] = "#cdcdcd"; // 終わってる感を出す背景色
      tmp_btn_color_arr[arrayIndex][1] = "#b0b0b0"; // 終わってる感を出す文字色
      setSelectedSquare(tmp_arr);
      setBtnColor(tmp_btn_color_arr);

      setPlayer1Square(calcNextGrid(value, "set"));
      setGameStatusValue(2);
    }
  }
  let selectArea;
  if (isPC) {
    selectArea = css`//style
      z-index: 2147483647;
      background-color: #ffffff5f;
      center {
        z-index: 2147483647;
        margin-top: 0px;
        font-family: 'Zen Kaku Gothic New';
        font-weight: bold;

      }
      margin: 45vh auto 0 auto;

      /* border: 2px solid #dadada; */
      width: auto;
      height: 300px;

      display: ${props.selectAreaDisplay};
      div {

        margin: 0 auto 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        /* background-color: #ffffff72; */
        /* backdrop-filter: blur(5px); */

        width: auto;
        height: 150px;
        button {
          font-size: 30px;
          border: 1px solid #555555;
          width: 100px;
          height: 100px;
          margin: 0 10px;
        }
        button:hover {
          cursor: pointer;
        }



        /*== 影が拡がって浮き上がる */

      /*ボタンの形状*/
      .selectBtn {
          border: 1px solid #ccc;
          padding:10px 20px;
          display: inline-block;
          text-decoration: none;
          outline: none;
          box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2), 0 0 40px rgba(128, 128, 128, 0.1) ;
          /*アニメーションの設定*/
          transition: all .3s;
      }

      /*hoverをしたらボックスの影が拡がり色が濃くなる*/
      .selectBtn:hover {
          box-shadow: 0 1px 10px rgba(0, 0, 0, 0.4), 0 0 50px rgba(128, 128, 128, 0.1) ;
          border-color: transparent;
      }


      /*========= レイアウトのためのCSS ===============*/

      body{
          vertical-align:middle;
          padding: 100px 0;
          text-align: center;
      }p{
          margin: 0 0 10px 0;
      }
      }
    `;

  } else {
    selectArea = css`//style
      scale: 0.8;
      margin-top: 170px;
      z-index: 2147483647;
      background-color: #ffffff5f;
      center {
        margin-top: 50px;
        font-family: 'Zen Kaku Gothic New';
        font-weight: bold;

      }
      /* margin: 30px auto 0 37vw; */
      /* border: 2px solid #dadada; */
      display: ${props.selectAreaDisplay};
      div {
        /* margin: 0 auto 50px auto; */
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #ffffff72;
        backdrop-filter: blur(5px);

        /* width: 500px; */
        /* height: 150px; */
        button {
          font-size: 30px;
          border: 1px solid #555555;
          width: 80px;
          height: 80px;
          margin: 0 5px;
        }
        button:hover {
          cursor: pointer;
        }



        /*== 影が拡がって浮き上がる */

      /*ボタンの形状*/
      .selectBtn {
          border: 1px solid #ccc;
          padding:10px 20px;
          display: inline-block;
          text-decoration: none;
          outline: none;
          box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2), 0 0 40px rgba(128, 128, 128, 0.1) ;
          /*アニメーションの設定*/
          transition: all .3s;
      }

      /*hoverをしたらボックスの影が拡がり色が濃くなる*/
      .selectBtn:hover {
          box-shadow: 0 1px 10px rgba(0, 0, 0, 0.4), 0 0 50px rgba(128, 128, 128, 0.1) ;
          border-color: transparent;
      }


      /*========= レイアウトのためのCSS ===============*/

      body{
          vertical-align:middle;
          padding: 100px 0;
          text-align: center;
      }p{
          margin: 0 0 10px 0;
      }
      }
    `;
  }

  const btn1 = css`
    background-color: ${btnColor[0][0]};
    color: ${btnColor[0][1]};
    border-radius: 100%;
  `;
  const btn2 = css`

    background-color: ${btnColor[1][0]};
    color: ${btnColor[1][1]};
    border-radius: 100%;
  `;
  const btn3 = css`
    background-color: ${btnColor[2][0]};
    color: ${btnColor[2][1]};
    border-radius: 100%;
  `;



  return (
    <>
      <div css={selectArea}>
        <div >
          {/* 進マス数を選択するボタン。押したらそれぞれの処理が実行される */}
          {
            isPC ?
              <>
                <button css={btn1} className="selectBtn" onClick={() => handleSelect(1)} onMouseEnter={() => handleHover(1, "hover")} onMouseLeave={() => handleHover(1, "leave")}>1</button>
                <button css={btn2} className="selectBtn" onClick={() => handleSelect(2)} onMouseEnter={() => handleHover(2, "hover")} onMouseLeave={() => handleHover(2, "leave")}>2</button>
                <button css={btn3} className="selectBtn" onClick={() => handleSelect(3)} onMouseEnter={() => handleHover(3, "hover")} onMouseLeave={() => handleHover(3, "leave")}>3</button>
              </> :
              <>
                <button css={btn1} className="selectBtn" onClick={() => handleSelect(1)}>1</button>
                <button css={btn2} className="selectBtn" onClick={() => handleSelect(2)}>2</button>
                <button css={btn3} className="selectBtn" onClick={() => handleSelect(3)}>3</button>
              </>
          }
        </div>
        <center>残り{props.cnt}回進むことができます。
        </center>
      </div>

    </>
  )
}

export default SelectMoveSquaresMenu
